import * as React from 'react';
import './Rubrics.css';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation, useParams } from 'react-router-dom';
import { StateStatus } from '../../types/models';
import { rubricsSelector } from '../../store/ducks/rubrics/selectors/rubricsSelector';
import { getRubrics, getRubricsIdle } from '../../store/ducks/rubrics/actions';
import { Helmet } from 'react-helmet';
import { RubricsSelectorType } from '../../store/ducks/rubrics/types';
import { Loading } from '../../components/UI/Loading/Loading';
import { useLocationHook } from '../../hooks/useLocationHook';
import { domainName } from '../../config'

export default function Rubrics() {
    const dispatch = useDispatch();

    const { url, statePopular } = useLocationHook();

    const history = useHistory();

    const status = useSelector(
        (state: { rubrics: { status: StateStatus } }) => state.rubrics.status
    );

    const { posts, count, title, buttons }: RubricsSelectorType = useSelector(
        rubricsSelector
    );
    useEffect(() => {
        if (status === 'IDLE') {
            dispatch(getRubrics({ slug: url, popular: statePopular }));
        }
    }, []);

    useEffect(() => {
        dispatch(getRubrics({ slug: url, popular: statePopular }));
    }, [url, statePopular]);

    const switchHandler = (id: string) => {
        history.push(`/posts/category/${url}?popular=${id}`);
        dispatch(getRubrics({ slug: url, popular: id }));
    };

    if (status === 'LOADING') return <Loading />;

    return (
        <>
            <Helmet>
                <title>{title}</title>
                <link rel="canonical" href={`https://${domainName}/posts/category/${url}`} />
                <meta property="og:title" content={title} />
                <meta property="twitter:title" content={title} />
                <meta name="description" content={`Рядом — Журнал Группы «Эталон» о том, что такое классный город в XXI веке, как в нем жить и как сделать его лучше. `} />
                <meta
                    property="og:description"
                    content={`Рядом — Журнал Группы «Эталон» о том, что такое классный город в XXI веке, как в нем жить и как сделать его лучше. `}
                />
                <meta
                    property="twitter:description"
                    content={`Рядом — Журнал Группы «Эталон» о том, что такое классный город в XXI веке, как в нем жить и как сделать его лучше. `}
                />
                <meta property="og:image" content={`https://${domainName}/img/ryadom_fb_share.jpg`} />
                <meta property="og:url" content={`https://${domainName}/posts/category/${url}`} />
            </Helmet>
            <main className="page">
                <div className="rubrics page__rubrics">
                    <div className="rubrics__container">
                        <h1 className="rubrics__title">{title}</h1>
                        <div className="filters rubrics__filters">
                            {buttons.map(b => {
                                return (
                                    <button
                                        key={b.id}
                                        className={`filters__item ${
                                            statePopular === b.id
                                                ? ' _active'
                                                : ''
                                        }`}
                                        onClick={() => switchHandler(b.id)}
                                    >
                                        {b.name} 
                                    </button>
                                );
                            })}
                        </div>
                        <ul className="rubrics__list">
                            {posts.map(post => {
                                return (
                                    <li className="rubrics__item" key={post.id}>
                                        <Link
                                            to={post.slug}
                                            className="rubrics__link"
                                        >
                                            <div className="rubrics__item-ibg">
                                                {post.image && (<>
                                                    <img
                                                    src={post.image}
                                                    alt="img"
                                                />
                                                </>)}
                                            </div>
                                            <div className="rubrics__content">
                                                <h3 className="rubrics__item-title">
                                                    {post.title}
                                                </h3>
                                                <p className="rubrics__item-text">
                                                    {post.description}
                                                </p>
                                            </div>
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </main>
        </>
    );
}
